var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHashingBitsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 497.078,
    height: 86.36,
    viewBox: "0 0 497.078 86.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41717",
    "data-name": "Group 41717",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "HashingBits",
    transform: "translate(126.078 71)",
    fill: "#fff",
    fontSize: 70,
    fontFamily: "VisbyCF-DemiBold, Visby CF",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "HashingBits")), /*#__PURE__*/React.createElement("g", {
    id: "Group_41716",
    "data-name": "Group 41716",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_4424_Converted_",
    "data-name": "4424 [Converted]",
    d: "M.669,47.216v-2.98Q14,36.558,17.128,24.754a11.726,11.726,0,0,1-6.205,2.165,9.813,9.813,0,0,1-7.742-3.73,13.573,13.573,0,0,1-3.175-9.12A13.421,13.421,0,0,1,4.155,4.052,14.135,14.135,0,0,1,14.415,0,12.533,12.533,0,0,1,24.639,5.156a20.04,20.04,0,0,1,4.084,12.815q0,10.823-8.233,19.345a31.575,31.575,0,0,1-19.821,9.9Z",
    transform: "translate(28.196 51.829) rotate(-169)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_4424_Converted_2",
    "data-name": "4424 [Converted]",
    d: "M.669,47.216v-2.98Q14,36.558,17.128,24.754a11.726,11.726,0,0,1-6.205,2.165,9.813,9.813,0,0,1-7.742-3.73,13.573,13.573,0,0,1-3.175-9.12A13.421,13.421,0,0,1,4.155,4.052,14.135,14.135,0,0,1,14.415,0,12.533,12.533,0,0,1,24.639,5.156a20.04,20.04,0,0,1,4.084,12.815q0,10.823-8.233,19.345a31.575,31.575,0,0,1-19.821,9.9Z",
    transform: "matrix(0.978, 0.208, -0.208, 0.978, 77.009, 34.204)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M0,45.85a42.543,42.543,0,0,1,2.009-5.115A81.1,81.1,0,0,1,13.883,23.382,99.836,99.836,0,0,1,34.342,5.663,44.238,44.238,0,0,1,44.937.365c.183-.183.548-.183.913-.365L43.658,2.74a85.784,85.784,0,0,0-6.941,9.133c-.183.365-.365.365-.731.365a19.859,19.859,0,0,1-4.749.731,5.783,5.783,0,0,0,2.192,1.461c.365.183,1.1.183,1.279.731,0,.365-.548.913-.731,1.279a2.633,2.633,0,0,1-2.009,1.644,18.365,18.365,0,0,1-4.567.731c0,.365.183.365.365.548a10.154,10.154,0,0,0,3.105,1.644c.365.183.365.365.183.731A2.424,2.424,0,0,1,29.044,23.2,32.936,32.936,0,0,1,21.92,24.66h-.183a10.038,10.038,0,0,0,1.644,1.279,19.477,19.477,0,0,0,3.471,1.279c.183,0,.365.183.183.365a14.111,14.111,0,0,1-3.105,3.471c-.913.913-2.009.913-3.288.913h-4.2a19.854,19.854,0,0,0-3.288.183,3.388,3.388,0,0,0-2.192,1.279C9.133,35.438,8.037,38,6.759,40.37l-.548,1.1a3.869,3.869,0,0,1-2.557,2.74A12.608,12.608,0,0,0,0,45.85Z",
    transform: "translate(26.846 24.146) rotate(-11)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashingBitsIcon);
export default __webpack_public_path__ + "static/media/HashingBitsIcon.5b2cffc6111a6818d5f69c56181a20f7.svg";
export { ForwardRef as ReactComponent };